(function(){
  var barra = document.getElementById('eg-carrello');
  var numero = document.getElementById('eg-carrello-n');
  function mostraTotale(n){ if(!barra) return; numero.textContent = n; barra.hidden = !(n > 0); }
  function leggiCarrello(){
    return fetch('/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(c){ mostraTotale(c.item_count); })
      .catch(function(){});
  }
  leggiCarrello();

  function aggiungi(idVariante){
    return fetch('/cart/add.js', {method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id: Number(idVariante), quantity: 1}]})})
      .then(function(r){ if(!r.ok) throw new Error('add'); return leggiCarrello(); })
      .then(function(){ document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true})); });
  }

  document.querySelectorAll('.eg-aggiungi').forEach(function(btn){
    btn.addEventListener('click', function(){
      if (btn.disabled) return;
      var testo = btn.textContent;
      btn.disabled = true; btn.textContent = 'Aggiungo…';
      aggiungi(btn.getAttribute('data-variante'))
        .then(function(){ btn.textContent = '✓ Nel carrello'; btn.classList.add('eg-fatto'); btn.disabled = false; })
        .catch(function(){ btn.textContent = 'Riprova'; btn.disabled = false;
          setTimeout(function(){ btn.textContent = testo; }, 2000); });
    });
  });

  // ---------------- sfogliatore ----------------
  var foto = [].slice.call(document.querySelectorAll('.eg-img[data-sfoglia]'));
  if (!foto.length) return;
  var visore = document.getElementById('eg-visore');
  var img = document.getElementById('eg-visore-img');
  var nome = document.getElementById('eg-visore-nome');
  var conta = document.getElementById('eg-visore-conta');
  var prezzo = document.getElementById('eg-visore-prezzo');
  var btnAgg = document.getElementById('eg-visore-aggiungi');
  var btnPrec = document.getElementById('eg-prec');
  var btnSucc = document.getElementById('eg-succ');
  var corrente = -1;

  function precarica(i){
    if (i < 0 || i >= foto.length) return;
    var p = new Image(); p.src = foto[i].getAttribute('data-grande');
  }

  function mostra(i){
    if (i < 0 || i >= foto.length) return;
    corrente = i;
    var el = foto[i];
    img.src = el.getAttribute('data-grande');
    img.alt = el.getAttribute('data-nome') || '';
    nome.textContent = el.getAttribute('data-nome') || '';
    conta.textContent = (i + 1) + ' di ' + foto.length;
    prezzo.textContent = el.getAttribute('data-prezzo') || '';
    var disponibile = el.getAttribute('data-disponibile') === '1';
    btnAgg.disabled = !disponibile;
    btnAgg.classList.remove('eg-fatto');
    btnAgg.textContent = disponibile ? 'Aggiungi al carrello' : 'Non disponibile';
    btnAgg.setAttribute('data-variante', el.getAttribute('data-variante'));
    btnPrec.disabled = (i === 0);
    btnSucc.disabled = (i === foto.length - 1);
    precarica(i + 1); precarica(i - 1);
  }

  function apri(i){
    // in anteprima tema la barra di Shopify sta incollata in fondo allo
    // schermo e coprirebbe "Aggiungi al carrello": alziamo la nostra.
    // Sul sito pubblicato quella barra non c'e' e questo non scatta.
    if (document.getElementById('PBarNextFrame') || document.querySelector('#preview-bar-iframe')) {
      visore.classList.add('eg-anteprima');
    }
    visore.hidden = false;
    document.body.classList.add('eg-bloccato');
    mostra(i);
  }
  function chiudi(){
    visore.hidden = true;
    document.body.classList.remove('eg-bloccato');
    // la foto aperta resta quella che si stava guardando: tornando alla
    // griglia si riprende da li' invece che dall'inizio della pagina
    if (corrente >= 0) foto[corrente].scrollIntoView({block:'center'});
  }

  foto.forEach(function(el, i){
    el.addEventListener('click', function(e){
      e.preventDefault();      // niente cambio pagina: si sfoglia qui
      apri(i);
    });
  });

  btnPrec.addEventListener('click', function(){ mostra(corrente - 1); });
  btnSucc.addEventListener('click', function(){ mostra(corrente + 1); });
  document.getElementById('eg-chiudi').addEventListener('click', chiudi);

  visore.addEventListener('click', function(e){
    // toccare lo sfondo nero chiude; toccare foto o barra no
    if (e.target === visore || e.target.classList.contains('eg-visore-foto')) chiudi();
  });

  document.addEventListener('keydown', function(e){
    if (visore.hidden) return;
    if (e.key === 'Escape') chiudi();
    else if (e.key === 'ArrowRight') mostra(corrente + 1);
    else if (e.key === 'ArrowLeft') mostra(corrente - 1);
  });

  // swipe col dito: conta solo un gesto orizzontale deciso, cosi' lo
  // scorrimento verticale della pagina non fa cambiare foto per sbaglio
  var xPartenza = 0, yPartenza = 0, tempoPartenza = 0;
  var zona = document.querySelector('.eg-visore-foto');
  zona.addEventListener('touchstart', function(e){
    var t = e.changedTouches[0];
    xPartenza = t.clientX; yPartenza = t.clientY; tempoPartenza = Date.now();
  }, {passive:true});
  zona.addEventListener('touchend', function(e){
    var t = e.changedTouches[0];
    var dx = t.clientX - xPartenza, dy = t.clientY - yPartenza;
    if (Date.now() - tempoPartenza > 800) return;
    if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    mostra(corrente + (dx < 0 ? 1 : -1));
  }, {passive:true});

  btnAgg.addEventListener('click', function(){
    if (btnAgg.disabled) return;
    btnAgg.disabled = true; btnAgg.textContent = 'Aggiungo…';
    aggiungi(btnAgg.getAttribute('data-variante'))
      .then(function(){
        btnAgg.textContent = '✓ Nel carrello'; btnAgg.classList.add('eg-fatto'); btnAgg.disabled = false;
        // la stessa foto nella griglia sotto si segna come presa
        var gemello = foto[corrente].closest('.eg-card').querySelector('.eg-aggiungi');
        if (gemello){ gemello.textContent = '✓ Nel carrello'; gemello.classList.add('eg-fatto'); }
      })
      .catch(function(){ btnAgg.textContent = 'Riprova'; btnAgg.disabled = false; });
  });
})();
